import React from 'react';
import { Headline } from '@xingternal/typography';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Page } from '../../models/page';
import { groupBy } from '../../utils';
import styles from './PagesSections.css';

interface PageSectionsProps {
  pages: Page[];
  pageLink: (page: Page) => string;
}

// First show B2C, then B2B
const sortTerms = (first: string, second: string) => {
  if (first === 'B2C') {
    return -1;
  }

  if (second === 'B2C') {
    return 1;
  }

  if (first === 'B2B') {
    return -1;
  }

  if (second === 'B2B') {
    return +1;
  }

  return first.localeCompare(second);
};

const GroupDescription = ({ groupName }: { groupName: string }) => {
  if (groupName === 'B2B') {
    return (
      <FormattedMessage
        id={'LEGAL_PAGES_TERMS_AND_CONDITIONS_B2B_DESCRIPTION'}
      />
    );
  }

  if (groupName === 'B2C') {
    return (
      <FormattedMessage
        id={'LEGAL_PAGES_TERMS_AND_CONDITIONS_B2C_DESCRIPTION'}
      />
    );
  }

  return <span>{groupName}</span>;
};

export const PageSections = ({
  pages,
  pageLink,
}: PageSectionsProps): React.ReactElement => {
  const terms = groupBy(pages, item => item.groupName);

  return (
    <>
      {[...terms]
        .sort((first, second) => sortTerms(first[0], second[0]))
        .map(term => {
          const groupName = term[0];
          const pages = term[1].sort((a, b) =>
            a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1
          );

          return (
            <div className={styles.section} key={groupName}>
              <Headline className={styles.title} as="h1">
                <GroupDescription groupName={groupName} />
              </Headline>

              <ul className={styles.termList}>
                {pages.map(page => (
                  <Link
                    key={page.slug}
                    className={styles.termLink}
                    to={pageLink(page)}
                  >
                    <li className={styles.termListItem}>{page.name}</li>
                  </Link>
                ))}
              </ul>
            </div>
          );
        })}
    </>
  );
};
